// Module
var code = `<h2 class="section-header">Loan batch pre-termination upload</h2>

<form name="\$ctrl.form" novalidate>
  <table class="table table--generate-row-ids">
    <tbody>
      <tr>
        <td></td>
        <td>Pre-termination type:</td>
        <td>
          <input type="text" disabled value="Pre-terminate by GL" />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>GL category:</td>
        <td>
          <gl-category-select
              required
              ng-model="\$ctrl.category"
              action-type="'LOAN_BATCH_GL_PRETERMINATION'"
              single-accounts-only="true"
              is-selectize="true"
              ng-change="\$ctrl.categoryChanged()"
          >
          </gl-category-select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Account:</td>
        <td>
          <input type="text" disabled ng-value="\$ctrl.category.ledgerAccountFullCodes[0]" />
        </td>
      </tr>
      <tr ng-if="!\$ctrl.autoOfficialReceiptEnabled">
        <td></td>
        <td>Invoice:</td>
        <td>
          <input name="officialReceipt"
                 class="form-control"
                 ng-model="\$ctrl.preterminate.officialReceipt"
                 type="text"
                 ng-change="\$ctrl.clearSimulation()"
                 required/>
        </td>
      </tr>
      <tr ng-if="\$ctrl.autoOfficialReceiptEnabled">
        <td></td>
        <td>Invoice start:</td>
        <td>
          <input name="officialReceiptStart"
                 class="form-control"
                 ng-if="\$ctrl.officialReceiptStart"
                 ng-model="\$ctrl.officialReceiptStart"
                 type="text"
                 disabled
                 required/>
          <div class="alert alert--danger" ng-if="!\$ctrl.officialReceiptStart">
            User has no available invoice!
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Remarks:</td>
        <td>
          <input
            type="text"
            ng-model="\$ctrl.preterminate.remarks"
            ng-change="\$ctrl.clearSimulation()"
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File:</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-model="\$ctrl.preterminate.attachedFileId"
            validate="{pattern: '.csv,*.txt', size: { max: '5MB'}}"
            enable-webcam="false"
            max-files="1"
            show-remarks="false"
            ng-change="\$ctrl.clearSimulation()"
            required
          >
          </file-id-upload>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Skip simulation:
          <help title="Skipping simulation improves performance. If a pre-termination fails during processing it will be skipped and the remaining rows of the file will be processed." ></help>
        </td>
        <td>
          <select required
                  name="skipSimulation"
                  boolean-options
                  ng-change="\$ctrl.clearSimulation()"
                  ng-model="\$ctrl.skipSimulation">
          </select>
        </td>
      </tr>
    </tbody>
  </table>

  <div ng-if="\$ctrl.simulation">
    <h2 class="section-header">File summary</h2>

    <div ng-if="\$ctrl.simulation.perRowFormatErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has format errors:
      </div>

      <dynamic-list
        columns="\$ctrl.formatErrorColumns"
        data="\$ctrl.simulation.perRowFormatErrors"
        list-type="'ERROR'"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowBusinessErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has pre-termination errors:
      </div>

      <dynamic-list
        columns="\$ctrl.simulation.businessErrorColumns"
        data="\$ctrl.simulation.perRowBusinessErrors"
        list-type="'ERROR'"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowSuccessfulRows.length > 0">
      <div class="alert file-error-alert" >
        Valid rows:
      </div>

      <dynamic-list
        columns="\$ctrl.simulation.successfulColumns"
        data="\$ctrl.simulation.perRowSuccessfulRows"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>
  </div>

  <div class="summary-actions">
    <button
        type="button"
        class="btn btn-info"
        ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.resetForm()">
      Clear form
    </button>
    <button
      ng-if="!\$ctrl.simulation && !\$ctrl.skipSimulation"
      type="button"
      class="btn btn-success"
      ng-click="\$ctrl.simulatePretermination()"
      ng-disabled="\$ctrl.form.\$invalid">
      Upload file
    </button>
    <button
        ng-if="\$ctrl.simulation || \$ctrl.skipSimulation"
        type="button"
        class="btn btn-success"
        ng-click="\$ctrl.submitPretermination()"
        ng-disabled="\$ctrl.form.\$invalid">
      Submit payment
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/loan-pretermination/batch-loan-preterminations-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;